module.exports = __webpack_public_path__ + "static/media/Bronze.a36957ff.png";